import { title, titleReverse, titleSeparator } from '@/config'
import i18n from '@/i18n'

/**
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export default function getPageTitle(pageTitle) {
  const { t, te } = i18n.global
  if (te(`vabI18n.${pageTitle}`)) pageTitle = t(`vabI18n.${pageTitle}`)
  let newTitles = []
  if (pageTitle) newTitles.push(pageTitle)
  if (title) newTitles.push(title)
  if (titleReverse) newTitles = newTitles.reverse()
  return newTitles.join(titleSeparator)
}
//设置favicon
/**
 * 设置header相关信息
 * @param {String} title
 * @param {String} fav
 */
 const collectionToArray = (collection) => {
  const ary = [];
  for (let i = 0, len = collection.length; i < len; i += 1) {
    ary.push(collection[i]);
  }
  return ary;
};
 export const initSystemShow = (title = oStatic.SYS_NAME, fav = './favicon.ico') => {
  document.title = title;
  const links = document.querySelectorAll('link[rel=icon]');
  const linksItems = collectionToArray(links);
  const favicon = linksItems[0];
  favicon.href = fav;
};